import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getVolumeLeagues} from '../../../apis/volume_league/list'

/**
 * Volume League 목록 조회 (모든 상태).
 * 문서상 단건 상세 엔드포인트가 없어 목록만 제공 — 상세는 목록 데이터에서 find.
 */
const useQueryVolumeLeagues = () => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.volumeLeague.getVolumeLeagues(),
        queryFn: async () => {
            const {data} = await getVolumeLeagues()
            return data
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    })

    return {data, refetch, isLoading}
}

export default useQueryVolumeLeagues
